import { createSlice, current } from "@reduxjs/toolkit";

const initialState = {
  dineinItems: [],
  takeawayItems: [],
  deliveryItems: [],
  scheduledordersItems: [],
  tablereservaionItems: [],
  activeCart: "Dine In",
};

const getActiveCartKey = (activeCart) => {
  return `${activeCart.toLocaleLowerCase().replace(" ", "")}Items`;
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addItemToCart(state, action) {
      const activeCart = getActiveCartKey(current(state).activeCart);
      const newItemId = action.payload.id;
      const itemIndex = current(state[activeCart]).findIndex(
        (item) => newItemId === item.item_id
      );
      if (itemIndex === -1) {
        const item = {
          cat_id: action.payload.category.id,
          cat_name: action.payload.category.name,
          item_id: action.payload.id,
          item_name: action.payload.name,
          price: action.payload.price,
          quantity: 1,
          type: current(state)
            .activeCart.replace(/[A-Z]/g, " $&")
            .toLocaleLowerCase(),
        };
        state[activeCart].push(item);
      } else {
        state[activeCart][itemIndex].quantity++;
      }
    },
    removeItemFromCart(state, action) {
      const activeCart = getActiveCartKey(current(state).activeCart);
      state[activeCart].splice(action.payload, 1);
    },
    reduceItemFromCart(state, action) {
      const activeCart = getActiveCartKey(current(state).activeCart);
      state[activeCart][action.payload - 1].quantity--;
    },
    increaseItemInCart(state, action) {
      const activeCart = getActiveCartKey(current(state).activeCart);
      state[activeCart][action.payload - 1].quantity++;
    },
    changeActiveCart(state, action) {
      state.activeCart = action.payload;
    },
    clearCart(state) {
      state.dineinItems = [];
      state.takeawayItems = [];
      state.deliveryItems = [];
    },
  },
});

export const {
  addItemToCart,
  removeItemFromCart,
  reduceItemFromCart,
  increaseItemInCart,
  changeActiveCart,
  clearCart,
} = cartSlice.actions;
export default cartSlice.reducer;
